import React, { useState, useContext } from "react";

import Select from "../Select/Select";
import countries from "../countries";
import {SquareContext} from "../../SquareContext"






export default function Fromarea(props) {

  const {
additionalForm, setAdditionalForm
  } = useContext(SquareContext)
 


  return (
    <>
      <form className="form-style">
        <ul>
        <li>
            <textarea
            value={additionalForm}
              name="field5"
              className="field-style-message"
              placeholder=""
              style={{resize: "none", width: "100%"}}
              onChange={(e) => setAdditionalForm(e.target.value)}
            ></textarea>
          </li>
          
       
         
         
        
        </ul>
      </form>
    </>
  );
}
